export default {
  getAccessToken(state) {
    state.accessToken = state.accessToken || localStorage.accessToken;
    return state.accessToken;
  },
  getUserData(state) {
    // state.userData = localStorage.userData || '{}';
    // return JSON.parse(state.userData);
    return state.userData;
  },

  getMainInfo(state) {
    return {
      bannerList: state.bannerList,
      studyList: state.studyList,
      noticeList: state.noticeList,
      paymentList: state.paymentList
    };
  },

  getStudyList(state) {
    return state.studyList;
  },

  getUserNo(state) {
    return state.userData.userNo;
  },

  getAuthCode(state) {
    return state.authCode;
  },

  getErrorMessage(state) {
    return state.message;
  }
};
